import { isEntityDisabled } from "./isEntityDisabled";

export const calcShouldDisableEntity = (
  entity: any,
  disabledTooltip: string,
  forbiddenRootFolderName: string,
  forbiddenExtensions: string[]
) => {
  const shouldDisableEntity = isEntityDisabled(
    entity,
    forbiddenRootFolderName,
    forbiddenExtensions
  );
  const extraData = {
    disabled: shouldDisableEntity,
    ...(shouldDisableEntity && {
      tooltipProps: {
        text: disabledTooltip,
        placement: "top",
        style: {
          maxWidth: "400px",
        },
      },
    }),
  };

  if (!entity.children || entity.children.length === 0) {
    return {
      ...entity,
      ...extraData,
    };
  }
  return {
    ...entity,
    ...extraData,
    children: entity.children.map((child: any) =>
      calcShouldDisableEntity(
        child,
        disabledTooltip,
        forbiddenRootFolderName,
        forbiddenExtensions
      )
    ),
  };
};
